  <template>
    <div class="operationworkflow">
      <div
        class="mobile-show"
        style="
      width: 100vw;
      height: calc(100vw * 0.125);
      position:absolute;
      z-index:-10;
      top:0;
      background: url(./img/mobile_header_bg1.jpg) center top  / cover;
      background-repeat: no-repeat;
      "
      ></div>
      <div class="container mobile-hide">
        <agile
          ref="imagecarousel"
          :autoplay="false"
          :speed="2000"
          :fade="true"
          :dots="false"
          :nav-buttons="false"
          style="height:400px;overflow:hidden;"
        >
          <div
            class="slide"
            style="background: url('./img/facilities_slide01.jpg') center center / cover;   "
          ></div>
          <div
            class="slide"
            style="background: url('./img/facilities_slide02.jpg') center center / cover;   "
          ></div>
          <div
            class="slide"
            style="background: url('./img/facilities_slide03.jpg') center center / cover;   "
          ></div>
        </agile>
        <div
          style="
        width: 100%;
        height: 133px;
        position: absolute;
        top: 370px;
        background: url(./img/facilities_overlay.png) center center / cover;
        mix-blend-mode:multiply;
        "
        ></div>
        <div style="position:absolute;top:0;">
          <agile
            id="word-agile"
            :autoplay="true"
            :speed="2000"
            :autoplay-speed="5000"
            :fade="true"
            :dots="false"
            :nav-buttons="false"
            style="height:600px;overflow:hidden;"
            @beforeChange="syncslide"
          >
            <div class="slide" style="width:100%;">
              <div class="slide-overlay">
                <img src="img/chinese_diligent.png" alt width="48" />
              </div>
            </div>
            <div class="slide" style="width:100%;">
              <div class="slide-overlay">
                <img src="img/chinese_reliable.png" alt width="48" />
              </div>
            </div>
            <div class="slide" style="width:100%;">
              <div class="slide-overlay">
                <img src="img/chinese_precision.png" alt width="48" />
              </div>
            </div>
          </agile>
        </div>
      </div>
      <div class="mobile-unpad">
        <div
          class="container mobile-padding mobile-bg-blue"
          style="text-align:left;padding-bottom:20px;"
        >
          <div class="mobile-show" style="padding-top:30px;"></div>
          <div class="grid-container">
            <div class="grid1">
              <span class="title-size line-height">
                {{$t('body.facilities_workflow_title1')}}
                <br />
                {{$t('body.facilities_workflow_title2')}}
              </span>
            </div>
            <div class="grid2 mobile-tablet-hide">
              <div class="flowtab close" id="flowtab1">
                <div class="flowtab-header" @click="toggleFlowtab('flowtab1')">
                  <div class="flowarrow"></div>
                  <div style="display:flex; ">
                    <div
                      style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                    >1</div>
                    <div
                      style="flex:10;
                      padding-top: 6px;
                      font-size: 24px;
                      font-weight: 900;
                  "
                    >
                      <div class="bar-title">{{$t('body.facilities_workflow_1_title1')}}</div>
                      <div
                        style="position:relative;top:-8px;"
                      >{{$t('body.facilities_workflow_1_title2')}}</div>
                    </div>
                    <div
                      style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 21px;
                  "
                    >
                      <font-awesome-icon
                        icon="plus"
                        id="plusbutton"
                        style="height:24px; width:24px;cursor:pointer;"
                      />
                    </div>
                  </div>
                </div>
                <!-- xxxx -->
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_1b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.1</div>
                      <div>{{$t('body.facilities_workflow_1p1')}}</div>
                    </div>
                  </div>
                </div>
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_2a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_2b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.2</div>
                      <div>{{$t('body.facilities_workflow_1p2')}}</div>
                    </div>
                  </div>
                </div>
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_3a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_3b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.3</div>
                      <div>{{$t('body.facilities_workflow_1p3')}}</div>
                    </div>
                  </div>
                </div>
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_4a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_4b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900;">1.4</div>
                      <div>{{$t('body.facilities_workflow_1p4')}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flowtab close" id="flowtab2">
                <div class="flowtab-header" @click="toggleFlowtab('flowtab2')">
                  <div class="flowarrow"></div>
                  <div style="display:flex; ">
                    <div
                      style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                    >2</div>
                    <div
                      style="flex:10;
                      padding-top: 6px;
                      font-size: 24px;
                      font-weight: 900;
                  "
                    >
                      <div class="bar-title">{{$t('body.facilities_workflow_2_title1')}}</div>
                      <div
                        style="position:relative;top:-8px;"
                      >{{$t('body.facilities_workflow_2_title2')}}</div>
                    </div>
                    <div
                      style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 21px;
                  "
                    >
                      <font-awesome-icon
                        icon="plus"
                        id="plusbutton"
                        style="height:24px; width:24px;"
                      />
                    </div>
                  </div>
                </div>
<!-- yyy -->
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_1b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.1</div>
                      <div>{{$t('body.facilities_workflow_2p1')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_2a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_2b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.2</div>
                      <div>{{$t('body.facilities_workflow_2p2')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_3a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_3b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.3</div>
                      <div>{{$t('body.facilities_workflow_2p3')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_4a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_4b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.4</div>
                      <div>{{$t('body.facilities_workflow_2p4')}}</div>
                      <div
                        style="font-weight:900; font-family:AvenirBold;padding-top:8px;"
                      >{{$t('body.facilities_workflow_2p4_2')}}</div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="flowtab close" id="flowtab3">
                <div class="flowtab-header" @click="toggleFlowtab('flowtab3')">
                  <div class="flowarrow"></div>
                  <div style="display:flex; ">
                    <div
                      style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                    >3</div>
                    <div
                      style="flex:10;
                      padding-top: 6px;
                      font-size: 24px;
                      font-weight: 900;
                  "
                    >
                      <div class="bar-title" >{{$t('body.facilities_workflow_3_title1')}}</div>
                      <div
                        style="position:relative;top:-8px;"
                      >{{$t('body.facilities_workflow_3_title2')}}</div>
                    </div>
                    <div
                      style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 21px;
                  "
                    >
                      <font-awesome-icon
                        icon="plus"
                        id="plusbutton"
                        style="height:24px; width:24px;"
                      />
                    </div>
                  </div>
                </div>
                <!-- zzz -->
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_3_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_3_1b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">3.1</div>
                      <div>{{$t('body.facilities_workflow_3p1')}}</div>
                      <div
                        style="font-weight:900; font-family:AvenirBold;padding-top:8px;"
                      >{{$t('body.facilities_workflow_3p1_2')}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flowtab close" id="flowtab4">
                <div class="flowtab-header" @click="toggleFlowtab('flowtab4')">
                  <div class="flowarrow"></div>
                  <div style="display:flex; ">
                    <div
                      style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                    >4</div>
                    <div
                      style="flex:10;
                      padding-top: 6px;
                      font-size: 24px;
                      font-weight: 900;
                  "
                    >
                      <div class="bar-title" >{{$t('body.facilities_workflow_4_title1')}}</div>
                      <div
                        style="position:relative;top:-8px;"
                      >{{$t('body.facilities_workflow_4_title2')}}</div>
                    </div>
                    <div
                      style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 21px;
                  "
                    >
                      <font-awesome-icon
                        icon="plus"
                        id="plusbutton"
                        style="height:24px; width:24px;"
                      />
                    </div>
                  </div>
                </div>
<!-- QQQ -->
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_4_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <!-- <div
                            class="slide"
                            style="background: url('./img/wf_4_1b.jpg') center center / cover; height:248px;"
                          ></div>-->
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">4.1</div>
                      <div>{{$t('body.facilities_workflow_4p1')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/products_producttype01.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">4.2</div>
                      <div>{{$t('body.facilities_workflow_4p2')}}</div>
                    </div>
                  </div>
                </div>

                

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_4_4a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_4_4b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">4.3</div>
                      <div
                        style="font-weight:900; font-family:AvenirBold;"
                      >{{$t('body.facilities_workflow_4p4')}}</div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="flowtab close" id="flowtab5">
                <div
                  class="flowtab-header"
                  @click="toggleFlowtab('flowtab5'),toggleArrow('flowtab5arrow')"
                >
                  <div class="flowarrow hidable-arrow" id="flowtab5arrow"></div>
                  <div style="display:flex; ">
                    <div
                      style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                    >5</div>
                    <div
                      style="flex:10;
                      padding-top: 6px;
                      font-size: 24px;
                      font-weight: 900;
                  "
                    >
                      <div class="bar-title" >{{$t('body.facilities_workflow_5_title1')}}</div>
                      <div
                        style="position:relative;top:-8px;"
                      >{{$t('body.facilities_workflow_5_title2')}}</div>
                    </div>
                    <div
                      style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 21px;
                  "
                    >
                      <font-awesome-icon
                        icon="plus"
                        id="plusbutton"
                        style="height:24px; width:24px;"
                      />
                    </div>
                  </div>
                </div>
                <div class="flowinner">
                  <!-- <div class="flowinner-arrow"></div> -->
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_5_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_5_1b.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_5_1c.jpg') center center / cover; height:248px;"
                          ></div>
                          <!-- <div
                            class="slide"
                            style="background: url('./img/wf_5_1d.jpg') center center / cover; height:248px;"
                          ></div>-->
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">5.1</div>
                      <div>{{$t('body.facilities_workflow_5p1')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- mobile -->
        <!-- operation workflow-->
        <div class="mobile-tablet-show" style="text-align:left;">
          <div class="flowtab close" id="flowtabm1">
            <div class="flowtab-header" @click="toggleFlowtab('flowtabm1')">
              <div class="flowarrow"></div>
              <div style="display:flex; ">
                <div
                  style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                >1</div>
                <div
                  style="flex:10;
                    margin-left: 10px;
                      margin-right: 23px;
                      line-height:20px;
                      padding-top: 6px;
                      font-size: 16px;
                      font-weight: 900;
                  "
                >
                  <div class="bar-title" >{{$t('body.facilities_workflow_1_title1')}} {{$t('body.facilities_workflow_1_title2')}}</div>
                </div>
                <div
                  style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 10px;
                  "
                >
                  <font-awesome-icon
                    icon="plus"
                    id="plusbutton"
                    style="height:24px; width:24px;cursor:pointer;"
                  />
                </div>
              </div>
            </div>
            <div class="mobile-show">
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_1_1a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_1_1b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.1</div>
                  <div>{{$t('body.facilities_workflow_1p1')}}</div>
                </div>   
              </div>
            </div>
            
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_1_2a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_1_2b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.2</div>
                  <div>{{$t('body.facilities_workflow_1p2')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_1_3a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_1_3b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.3</div>
                  <div>{{$t('body.facilities_workflow_1p3')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_1_4a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_1_4b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.4</div>
                  <div>{{$t('body.facilities_workflow_1p4')}}</div>
                </div>
              </div>
            </div>
            </div>
            <!-- operation workflow 1 tablet -->
            <div class="tablet-show">
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_1b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.1</div>
                      <div>{{$t('body.facilities_workflow_1p1')}}</div>
                    </div>
                  </div>
                </div>
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_2a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_2b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.2</div>
                      <div>{{$t('body.facilities_workflow_1p2')}}</div>
                    </div>
                  </div>
                </div>
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_3a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_3b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.3</div>
                      <div>{{$t('body.facilities_workflow_1p3')}}</div>
                    </div>
                  </div>
                </div>
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_4a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_1_4b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900;">1.4</div>
                      <div>{{$t('body.facilities_workflow_1p4')}}</div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="flowtab close" id="flowtabm2">
            <div class="flowtab-header" @click="toggleFlowtab('flowtabm2')">
              <div class="flowarrow"></div>
              <div style="display:flex; ">
                <div
                  style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                >2</div>
                <div
                  style="flex:10;
                    margin-left: 10px;
                      margin-right: 23px;
                      line-height:20px;
                      padding-top: 6px;
                      font-size: 16px;
                      font-weight: 900;
                  "
                >
                  <div class="bar-title" >{{$t('body.facilities_workflow_2_title1')}} {{$t('body.facilities_workflow_2_title2')}}</div>
                </div>
                <div
                  style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 10px;
                  "
                >
                  <font-awesome-icon
                    icon="plus"
                    id="plusbutton"
                    style="height:24px; width:24px;cursor:pointer;"
                  />
                </div>
              </div>
            </div>
            <div class="mobile-show">
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_2_1a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_2_1b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.1</div>
                  <div>{{$t('body.facilities_workflow_2p1')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_2_2a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_2_2b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.2</div>
                  <div>{{$t('body.facilities_workflow_2p2')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_2_3a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_2_3b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.3</div>
                  <div>{{$t('body.facilities_workflow_2p3')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:470px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_2_4a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_2_4b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.4</div>
                  <div>{{$t('body.facilities_workflow_2p4')}}</div>
                  <div
                    style="font-weight:900; font-family:AvenirBold;padding-top:8px;"
                  >{{$t('body.facilities_workflow_2p4_2')}}</div>
                </div>
              </div>
            </div>
            </div>
            <div class="tablet-show">
              <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_1b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.1</div>
                      <div>{{$t('body.facilities_workflow_2p1')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_2a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_2b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.2</div>
                      <div>{{$t('body.facilities_workflow_2p2')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_3a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_3b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.3</div>
                      <div>{{$t('body.facilities_workflow_2p3')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_4a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_2_4b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.4</div>
                      <div>{{$t('body.facilities_workflow_2p4')}}</div>
                      <div
                        style="font-weight:900; font-family:AvenirBold;padding-top:8px;"
                      >{{$t('body.facilities_workflow_2p4_2')}}</div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="flowtab close" id="flowtabm3">
            <div class="flowtab-header" @click="toggleFlowtab('flowtabm3')">
              <div class="flowarrow"></div>
              <div style="display:flex; ">
                <div
                  style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                >3</div>
                <div
                  style="flex:10;
                    margin-left: 10px;
                      margin-right: 23px;
                      line-height:20px;
                      padding-top: 6px;
                      font-size: 16px;
                      font-weight: 900;
                  "
                >
                  <div class="bar-title" >{{$t('body.facilities_workflow_3_title1')}} {{$t('body.facilities_workflow_3_title2')}}</div>
                </div>
                <div
                  style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 10px;
                  "
                >
                  <font-awesome-icon
                    icon="plus"
                    id="plusbutton"
                    style="height:24px; width:24px;cursor:pointer;"
                  />
                </div>
              </div>
            </div>
            <div class="mobile-show">
            <div class="flowinner" style="height:450px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_3_1a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_3_1b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">3.1</div>
                  <div>{{$t('body.facilities_workflow_3p1')}}</div>
                  <div
                    style="font-weight:900; font-family:AvenirBold;padding-top:8px;"
                  >{{$t('body.facilities_workflow_3p1_2')}}</div>
                </div>
              </div>
            </div>
            </div>



            <div class="tablet-show">
              <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_3_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_3_1b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">3.1</div>
                      <div>{{$t('body.facilities_workflow_3p1')}}</div>
                      <div
                        style="font-weight:900; font-family:AvenirBold;padding-top:8px;"
                      >{{$t('body.facilities_workflow_3p1_2')}}</div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="flowtab close" id="flowtabm4">
            <div class="flowtab-header" @click="toggleFlowtab('flowtabm4')">
              <div class="flowarrow"></div>
              <div style="display:flex; ">
                <div
                  style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                >4</div>
                <div
                  style="flex:10;
                    margin-left: 10px;
                      margin-right: 23px;
                      line-height:20px;
                      padding-top: 10px;
                      font-size: 16px;
                      font-weight: 900;
                  "
                >
                  <div class="bar-title" >{{$t('body.facilities_workflow_4_title1')}} {{$t('body.facilities_workflow_4_title2')}}</div>
                </div>
                <div
                  style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 10px;
                  "
                >
                  <font-awesome-icon
                    icon="plus"
                    id="plusbutton"
                    style="height:24px; width:24px;cursor:pointer;"
                  />
                </div>
              </div>
            </div>
            <div class="mobile-show">
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_4_1a.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">4.1</div>
                  <div>{{$t('body.facilities_workflow_4p1')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/products_producttype01.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">4.2</div>
                  <div>{{$t('body.facilities_workflow_4p2')}}</div>
                </div>
              </div>
            </div>
            
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_4_4a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_4_4b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">4.3</div>
                  <div
                    style="font-weight:900; font-family:AvenirBold;"
                  >{{$t('body.facilities_workflow_4p4')}}</div>
                </div>
              </div>
            </div>
            </div>




            <div class="tablet-show">
              <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_4_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <!-- <div
                            class="slide"
                            style="background: url('./img/wf_4_1b.jpg') center center / cover; height:248px;"
                          ></div>-->
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">4.1</div>
                      <div>{{$t('body.facilities_workflow_4p1')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/products_producttype01.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">4.2</div>
                      <div>{{$t('body.facilities_workflow_4p2')}}</div>
                    </div>
                  </div>
                </div>

                

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_4_4a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_4_4b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">4.3</div>
                      <div
                        style="font-weight:900; font-family:AvenirBold;"
                      >{{$t('body.facilities_workflow_4p4')}}</div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="flowtab close" id="flowtabm5">
            <div
              class="flowtab-header"
              @click="toggleFlowtab('flowtabm5'),toggleArrow('flowtabm5arrow')"
            >
              <div class="flowarrow hidable-arrow" id="flowtabm5arrow"></div>
              <div style="display:flex; ">
                <div
                  style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                >5</div>
                <div
                  style="flex:10;
                    margin-left: 10px;
                      margin-right: 23px;
                      line-height:20px;
                      padding-top: 10px;
                      font-size: 16px;
                      font-weight: 900;
                  "
                >
                  <div class="bar-title" >{{$t('body.facilities_workflow_5_title1')}} {{$t('body.facilities_workflow_5_title2')}}</div>
                </div>
                <div
                  style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 10px;
                  "
                >
                  <font-awesome-icon
                    icon="plus"
                    id="plusbutton"
                    style="height:24px; width:24px;cursor:pointer;"
                  />
                </div>
              </div>
            </div>
<div class="mobile-show">
            <div class="flowinner" style="height:420px;">
              <!-- <div class="flowinner-arrow"></div> -->
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_5_1a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_5_1b.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_5_1c.jpg') center center / cover; height:200px;"
                  ></div>
                  
                </agile>
                <div style="flex:1;margin-top: 0px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">5.1</div>
                  <div>{{$t('body.facilities_workflow_5p1')}}</div>
                </div>
              </div>
            </div>
            </div>



            <div class="tablet-show">
              <div class="flowinner">
                  <!-- <div class="flowinner-arrow"></div> -->
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_5_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_5_1b.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_5_1c.jpg') center center / cover; height:248px;"
                          ></div>
                          <!-- <div
                            class="slide"
                            style="background: url('./img/wf_5_1d.jpg') center center / cover; height:248px;"
                          ></div>-->
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">5.1</div>
                      <div>{{$t('body.facilities_workflow_5p1')}}</div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <!-- mobile -->


                      <div
        v-if="this.$i18n.locale == 'cn'"
        class="container middle-separator line-bottom-right-140 mobile-hide">
        PRECISION
      </div>
      <div
        v-if="this.$i18n.locale == 'en'"
        class="container middle-separator line-bottom-right mobile-hide">
          <img style="position: relative; top: 6px;" src="img/chinese_accurate.jpg" alt width="55" />
      </div>

        <div class="container mobile-padding" style="text-align:left;margin-bottom:16px;">
          <div class="grid-container">
            <div class="grid1">
              <h1 class="title-size line-height">
                {{$t('body.facilities_workflow_title2_1')}}
                <br />
                {{$t('body.facilities_workflow_title2_2')}}
                <br />
                {{$t('body.facilities_workflow_title2_3')}}
              </h1>
            </div>

            <div class="grid2  mobile-tablet-hide">
              <div class="flowtab close" id="qctab1">
                <div
                  class="flowtab-header"
                  @click="toggleFlowtab('qctab1'), toggleArrow('qctab1arrow')"
                >
                  <div class="flowarrow hidable-arrow" id="qctab1arrow"></div>
                  <div style="display:flex; ">
                    <div
                      style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                    >1</div>
                    <div
                      style="flex:10;
                      padding-top: 6px;
                      font-size: 24px;
                      font-weight: 900;
                  "
                    >
                      <div class="bar-title" >{{$t('body.facilities_workflow_qctitle1_1')}}</div>
                      <div
                        style="position:relative;top:-8px;"
                      >{{$t('body.facilities_workflow_qctitle1_2')}}</div>
                    </div>
                    <div
                      style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 21px;
                  "
                    >
                      <font-awesome-icon
                        icon="plus"
                        id="plusbutton"
                        style="height:24px; width:24px;"
                      />
                    </div>
                  </div>
                </div>
                <!-- xxxxx -->
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc1b.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc1c.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc1d.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.1</div>
                      <div>{{$t('body.facilities_workflow_qc1')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.2</div>
                      <div>{{$t('body.facilities_workflow_qc2')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc3a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc3b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.3</div>
                      <div>{{$t('body.facilities_workflow_qc3')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <!-- <div class="flowinner-arrow"></div> -->
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc4a.jpg') center center / cover; height:248px;"
                          ></div>
                          <!-- <div
                            class="slide"
                            style="background: url('./img/wf_qc4b.jpg') center center / cover; height:248px;"
                          ></div>-->
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc4c.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc4d.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.4</div>
                      <div>{{$t('body.facilities_workflow_qc4')}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flowtab close" id="qctab2">
                <div
                  class="flowtab-header"
                  @click="toggleFlowtab('qctab2'),toggleArrow('qctab2arrow')"
                >
                  <div class="flowarrow hidable-arrow" id="qctab2arrow"></div>
                  <div style="display:flex; ">
                    <div
                      style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                    >2</div>
                    <div
                      style="flex:10;
                      padding-top: 6px;
                      font-size: 24px;
                      font-weight: 900;
                  "
                    >
                      <div class="bar-title" >{{$t('body.facilities_workflow_qctitle2_1')}}</div>
                      <div
                        style="position:relative;top:-8px;"
                      >{{$t('body.facilities_workflow_qctitle2_2')}}</div>
                    </div>
                    <div
                      style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 21px;
                  "
                    >
                      <font-awesome-icon
                        icon="plus"
                        id="plusbutton"
                        style="height:24px; width:24px;"
                      />
                    </div>
                  </div>
                </div>

                <!-- myyyy -->
                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_1b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.1</div>
                      <div>{{$t('body.facilities_workflow_qc2_1')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_2a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_2b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.2</div>
                      <div>{{$t('body.facilities_workflow_qc2_2')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <!-- <div class="flowinner-arrow"></div> -->
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_3a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_3b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.3</div>
                      <div>{{$t('body.facilities_workflow_qc2_3')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- mobile -->
        <div class="mobile-tablet-show">
          <div class="flowtab close" id="qctabm1">
            <div
              class="flowtab-header"
              @click="toggleFlowtab('qctabm1'), toggleArrow('qctabm1arrow')"
            >
              <div class="flowarrow hidable-arrow" id="qctabm1arrow"></div>
              <div style="display:flex; ">
                <div
                  style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        font-family:AvenirBold;
                        top: -7px;
                        left: 7px;
                        "
                >1</div>
                <div
                  style="flex:10;
                    margin-left: 10px;
                      margin-right: 23px;
                      line-height:20px;
                      padding-top: 10px;
                      font-size: 16px;
                      font-weight: 900;
                      text-align:left;
                  "
                >
                  <div class="bar-title" >{{$t('body.facilities_workflow_qctitle1_1')}}</div>
                  <div>{{$t('body.facilities_workflow_qctitle1_2')}}</div>
                </div>
                <div
                  style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 21px;
                  "
                >
                  <font-awesome-icon icon="plus" id="plusbutton" style="height:24px; width:24px;" />
                </div>
              </div>
            </div>

<!-- mxxxxx -->
<div class="mobile-show">
            <div class="flowinner" style="height:420px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc1a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc1b.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc1c.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc1d.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;text-align:left;">1.1</div>
                  <div>{{$t('body.facilities_workflow_qc1')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:400px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc2a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc2b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;text-align:left;">1.2</div>
                  <div>{{$t('body.facilities_workflow_qc2')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:400px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc3a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc3b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;text-align:left;">1.3</div>
                  <div>{{$t('body.facilities_workflow_qc3')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:400px;">
              <!-- <div class="flowinner-arrow"></div> -->
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc4a.jpg') center center / cover; height:200px;"
                  ></div>
                  <!-- <div
                    class="slide"
                    style="background: url('./img/wf_qc4b.jpg') center center / cover; height:200px;"
                  ></div>-->
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc4c.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc4d.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;text-align:left;">1.4</div>
                  <div>{{$t('body.facilities_workflow_qc4')}}</div>
                </div>
              </div>
            </div>
            </div>



            <div class="tablet-show">
              <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc1b.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc1c.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc1d.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.1</div>
                      <div>{{$t('body.facilities_workflow_qc1')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.2</div>
                      <div>{{$t('body.facilities_workflow_qc2')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc3a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc3b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.3</div>
                      <div>{{$t('body.facilities_workflow_qc3')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <!-- <div class="flowinner-arrow"></div> -->
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc4a.jpg') center center / cover; height:248px;"
                          ></div>
                          <!-- <div
                            class="slide"
                            style="background: url('./img/wf_qc4b.jpg') center center / cover; height:248px;"
                          ></div>-->
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc4c.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc4d.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">1.4</div>
                      <div>{{$t('body.facilities_workflow_qc4')}}</div>
                    </div>
                  </div>
                </div>
            </div>
          </div>

          <div class="flowtab close" id="qctabm2">
            <div
              class="flowtab-header"
              @click="toggleFlowtab('qctabm2'), toggleArrow('qctabm2arrow')"
            >
              <div class="flowarrow hidable-arrow" id="qctabm2arrow"></div>
              <div style="display:flex; ">
                <div
                  style="flex:1;
                        font-size: 62px;
                        font-weight: 900;
                        position: relative;
                        top: -7px;
                        left: 7px;
                        "
                >2</div>
                <div
                  style="flex:10;
                    margin-left: 10px;
                      margin-right: 23px;
                      line-height:20px;
                      padding-top: 10px;
                      font-size: 16px;
                      font-weight: 900;
                      text-align:left;
                  "
                >
                  <div class="bar-title" >{{$t('body.facilities_workflow_qctitle2_1')}}</div>
                  <div>{{$t('body.facilities_workflow_qctitle2_2')}}</div>
                </div>
                <div
                  style="flex:1;
                  text-align:right;
                  position: relative;
                  top: 25px;
                  right: 21px;
                  "
                >
                  <font-awesome-icon icon="plus" id="plusbutton" style="height:24px; width:24px;" />
                </div>
              </div>
            </div>

            <div class="mobile-show">
            <div class="flowinner" style="height:426px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc2_1a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc2_1b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.1</div>
                  <div>{{$t('body.facilities_workflow_qc2_1')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:400px;">
              <div class="flowinner-arrow"></div>
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc2_2a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc2_2b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.2</div>
                  <div>{{$t('body.facilities_workflow_qc2_2')}}</div>
                </div>
              </div>
            </div>
            <div class="flowinner" style="height:380px;">
              <!-- <div class="flowinner-arrow"></div> -->
              <div style="margin:16px;width:calc(100vw - 32px);height:300px;padding-top:16px;">
                <agile
                  :autoplay="true"
                  :speed="2000"
                  :autoplay-speed="5000"
                  :fade="true"
                  :dots="true"
                  :nav-buttons="false"
                  style="height:200px;overflow:hidden;"
                >
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc2_3a.jpg') center center / cover; height:200px;"
                  ></div>
                  <div
                    class="slide"
                    style="background: url('./img/wf_qc2_3b.jpg') center center / cover; height:200px;"
                  ></div>
                </agile>
                <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                  <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.3</div>
                  <div>{{$t('body.facilities_workflow_qc2_3')}}</div>
                </div>
              </div>
            </div>
            </div>
            <div class="tablet-show">

<div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_1a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_1b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.1</div>
                      <div>{{$t('body.facilities_workflow_qc2_1')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <div class="flowinner-arrow"></div>
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_2a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_2b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.2</div>
                      <div>{{$t('body.facilities_workflow_qc2_2')}}</div>
                    </div>
                  </div>
                </div>

                <div class="flowinner">
                  <!-- <div class="flowinner-arrow"></div> -->
                  <div style="display:flex;">
                    <div style="flex:1;">
                      <div style="margin:16px;background:white;width:300px;height:248px;">
                        <agile
                          :autoplay="true"
                          :speed="2000"
                          :autoplay-speed="5000"
                          :fade="true"
                          :dots="true"
                          :nav-buttons="false"
                          style="height:248px;overflow:hidden;"
                        >
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_3a.jpg') center center / cover; height:248px;"
                          ></div>
                          <div
                            class="slide"
                            style="background: url('./img/wf_qc2_3b.jpg') center center / cover; height:248px;"
                          ></div>
                        </agile>
                      </div>
                    </div>
                    <div style="flex:1;margin-top: 16px; margin-right:16px;text-align:left;">
                      <div style="font-size:50px;font-weight:900; font-family:AvenirBold;">2.3</div>
                      <div>{{$t('body.facilities_workflow_qc2_3')}}</div>
                    </div>
                  </div>
                </div>



            </div>
          </div>
        </div>
        <!-- mobile -->
      </div>
      <div style="position:relative;top:200px;">
        <vfooter></vfooter>
      </div>
    </div>
  </template>

  <script>
import EventBus from "../eventbus";
  // @ is an alias to /src
  export default {
    name: "about",
    mounted() {
    let self = this;
    if  ( this.$i18n.locale == "cn" ){
      self.changeToCN()
    } else {
      self.changeToEN()
    }
        EventBus.$on("changeEN", function() {
      self.changeToEN();
    });
    EventBus.$on("changeCN", function() {
      self.changeToCN();
    });
    },
    methods: {
      toggleFlowtab(s) {
        $(`#` + s).toggleClass("close");
      },
      toggleArrow(s) {
        $(`#` + s).toggleClass("show");
      },
      syncslide() {
        let self = this;
        console.log("syncslide");
        self.$refs.imagecarousel.goToNext();
    },
    changeToEN(){
      $(".bar-title").css("padding-top", "0");

    },
    changeToCN(){
      $(".bar-title").css("padding-top", "15px");

   }
    }
  };
  </script>

  <style scoped lang="scss">
  .hidable-arrow {
    display: none;
  }
  .hidable-arrow.show {
    display: block;
  }

  .flowinner {
    position: relative;
    margin-top: 17px;
    margin-bottom: 17px;
    background: #d0d2d3;
    min-height: 280px;
    width: 100%;
    transition: all 300ms ease-in-out;
    .flowinner-arrow {
      position: absolute;
      top: 100%;
      left: 50%;
      height: 20px;
      width: 20px;
      background: #d0d2d3;
      transform: translate(-50%, -50%) rotate(45deg);
      transition: all 300ms ease-in-out;
    }
  }
  .flowinner:hover {
    position: relative;
    margin-top: 17px;
    margin-bottom: 17px;
    background: #e2e4e4;
    height: 280px;
    width: 100%;
    transition: all 300ms ease-in-out;
    .flowinner-arrow {
      position: absolute;
      top: 100%;
      left: 50%;
      height: 20px;
      width: 20px;
      background: #e2e4e4;
      transform: translate(-50%, -50%) rotate(45deg);
      transition: all 300ms ease-in-out;
    }
  }

  .flowtab {
    position: relative;
    width: 100%;
    overflow: hidden;
    transition: 300ms all ease-in-out;
    #plusbutton {
      cursor: pointer;
      transform: rotate(45deg);
      transition: all 300ms ease-in-out;
    }
  }
  .flowtab-header {
    position: relative;
    height: 74px;
    width: 100%;
    color: #d0d2d3;
    background: #005567;
    cursor: pointer;
    transition: 300ms all ease-in-out;
    .flowarrow {
      position: absolute;
      top: 100%;
      left: 50%;
      height: 20px;
      width: 20px;
      background: #005567;
      transform: translate(-50%, -50%) rotate(45deg);
      transition: 300ms all ease-in-out;
    }
  }
  .flowtab-header:hover {
    position: relative;
    height: 74px;
    width: 100%;
    background: #053f57;
    color: white;
    cursor: pointer;
    transition: 300ms all ease-in-out;
    .flowarrow {
      position: absolute;
      top: 100%;
      left: 50%;
      height: 20px;
      width: 20px;
      background: #053f57;
      transform: translate(-50%, -50%) rotate(45deg);
      transition: 300ms all ease-in-out;
    }
  }

  .flowtab.close {
    height: 90px;
    width: 100%;
    overflow: hidden;
    transition: 300ms all ease-in-out;
    #plusbutton {
      transform: rotate(0deg);
      transition: all 300ms ease-in-out;
    }
  }

  .slide {
    width: 100%;
    height: 400px;
    // background: url("../assets/logo.png");
  }
  #word-agile div div div div.slide {
    width: 100%;
    height: 600px;
    // background: url("../assets/logo.png");
  }

  .slidetext {
    width: 500px;
    height: 400px;
    background: linear-gradient(to right, #013d57dd 70%, #013d5700);
    position: absolute;
    top: 0;
    left: 0;
    color: white;
    text-align: justify;
    padding: 24px 200px 0 24px;
    font-size: 20px;
  }
  .slide-overlay {
    height: 500px;
    font-size: 40px;
    line-height: 1;
    text-align: left;
    color: white;
    border-left: white solid 1px;
    position: relative;
    padding: 0 8px;
    top: 60px;
    left: 60px;
  }

  .slide-overlay::before {
    content: "";
    display: block;
    width: 4px;
    height: 100px;
    background: white;
    position: absolute;
    padding-left: 4px;
    top: 0;
    left: 0;
  }
  .grid-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: "menu" "main";
  }
  .grid1 {
    grid-area: menu;
  }
  .grid2 {
    grid-area: main;
  }
  .grid-container2 {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: "menu2" "main2";
  }
  .grid21 {
    grid-area: menu2;
  }
  .grid22 {
    grid-area: main2;
  }
  .line-height {
    line-height: 35px;
  }
  @media screen and (min-width: 768px) {
    .grid-container {
      display: grid;
      grid-template-columns: 1fr 1fr 1f;
      grid-template-areas: "menu main main";
      grid-gap: 10px;
      padding: 10px;
    }
    .line-height {
      line-height: 50px;
    }
  }
  @media screen and (min-width: 992px) {
    .grid-container {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-areas: "menu main main";
      grid-gap: 10px;
      padding: 10px;
    }
    .line-height {
      line-height: 50px;
    }
  }
  .bar-title{
padding-top: 0;
  }
  </style>
